import { createFileRoute } from "@tanstack/react-router";

import { SplitDetailPage } from "@/features/orders";

export const Route = createFileRoute("/_authenticated/split-orders_/$saleOrderId")({
  component: function SplitDetailRoute() {
    const { saleOrderId } = Route.useParams();
    return <SplitDetailPage saleOrderId={saleOrderId} />;
  },
});
